// DO NOT EDIT -- generated from fs/services/search-settings/computedproperties.proto

import * as protobuf from '../../../google/protobuf';
import * as realtime from '../../api/realtime';

export namespace ComputedPropertiesPublic {

  export const DeleteComputedPropertyEndpoint = "/grpc/search_settings.ComputedPropertiesPublic/DeleteComputedProperty";
  export function DeleteComputedProperty(sender: (req: DeleteComputedPropertyRequest, endpoint: string) => Promise<{}>, req: DeleteComputedPropertyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteComputedPropertyEndpoint),
      endpoint: DeleteComputedPropertyEndpoint
    };
  }

  export const GetAllComputedPropertiesEndpoint = "/grpc/search_settings.ComputedPropertiesPublic/GetAllComputedProperties";
  /** Get all latest computed properties for an org at their latest versions */
  export function GetAllComputedProperties(sender: (req: GetAllComputedPropertiesRequest, endpoint: string) => Promise<GetAllComputedPropertiesResponse>, req: GetAllComputedPropertiesRequest): { promise: () => Promise<GetAllComputedPropertiesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllComputedPropertiesEndpoint),
      endpoint: GetAllComputedPropertiesEndpoint
    };
  }

  export const GetComputedPropertyEndpoint = "/grpc/search_settings.ComputedPropertiesPublic/GetComputedProperty";
  /** Get a specific computed property, only the latest version */
  export function GetComputedProperty(sender: (req: GetComputedPropertyRequest, endpoint: string) => Promise<GetComputedPropertyResponse>, req: GetComputedPropertyRequest): { promise: () => Promise<GetComputedPropertyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetComputedPropertyEndpoint),
      endpoint: GetComputedPropertyEndpoint
    };
  }

  export const GetComputedPropertyWithHistoryEndpoint = "/grpc/search_settings.ComputedPropertiesPublic/GetComputedPropertyWithHistory";
  /** Get a specific computed property and all its previous versions */
  export function GetComputedPropertyWithHistory(sender: (req: GetComputedPropertyWithHistoryRequest, endpoint: string) => Promise<GetComputedPropertyWithHistoryResponse>, req: GetComputedPropertyWithHistoryRequest): { promise: () => Promise<GetComputedPropertyWithHistoryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetComputedPropertyWithHistoryEndpoint),
      endpoint: GetComputedPropertyWithHistoryEndpoint
    };
  }

  export const SetComputedPropertyEndpoint = "/grpc/search_settings.ComputedPropertiesPublic/SetComputedProperty";
  /** Add new or Update Computed Property */
  export function SetComputedProperty(sender: (req: SetComputedPropertyRequest, endpoint: string) => Promise<SetComputedPropertyResponse>, req: SetComputedPropertyRequest): { promise: () => Promise<SetComputedPropertyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetComputedPropertyEndpoint),
      endpoint: SetComputedPropertyEndpoint
    };
  }
}

export interface SetComputedPropertyRequest {
  orgId: string;
  computedProperty: ComputedPropertyIn | null;
}

export interface SetComputedPropertyResponse {
  computedProperty: ComputedProperty | null;
}

export interface GetComputedPropertyRequest {
  orgId: string;
  id: string;
}

export interface GetComputedPropertyResponse {
  computedProperty: ComputedProperty | null;
}

export interface GetAllComputedPropertiesRequest {
  orgId: string;
}

export interface GetAllComputedPropertiesResponse {
  computedProperties: ComputedProperty[];
}

export interface GetComputedPropertyWithHistoryRequest {
  orgId: string;
  id: string;
}

export interface GetComputedPropertyWithHistoryResponse {
  computedPropertyHistory: ComputedPropertyWithHistory[];
}

export interface DeleteComputedPropertyRequest {
  orgId: string;
  id: string;
}

export interface ComputedPropertyIn {
  id: string;
  computedPropertyDefinition: realtime.PropertyDefinition | null;
}

export interface ComputedProperty {
  id: string;
  computedPropertyDefinition: realtime.PropertyDefinition | null;
  updatedAt: protobuf.timestamp | null;
}

export interface ComputedPropertyWithHistory {
  id: string;
  computedPropertyDefinition: realtime.PropertyDefinition | null;
  updatedAt: protobuf.timestamp | null;
  historyId: number;
}
